import { romeApi, utils } from "framework";

const storeEmployerEdi = {
namespaced: true,
state: {
        employerEdiId: null,
        employerId: null,
        version: null,
        active: null,
        encrypts: null,
        sendsDemographics: null,
        sendsAccounts: null,
        sendsPayDeposits: null,
        sendsDependents: null,
        demographicFilePattern: null,
        accountFilePattern: null,
        payDepositFilePattern: null, 
        dependentFilePattern: null,
        uploadFolder: null,
        integratorId: null,
        ediProcessorId: null,
        splitIntegrator: null,
        sendsBulkFile: null,
        additionalIntegrators: [],
        contacts: [],
        files: []
    },
    apiGetters:{
        integrators: 'edi/integrators'
    }, 
    getters: {
        getEmployerEdi: state => {            
            return state;
        },
        getIsIHClient: state => {            
            return state.employerEdiId != null && state.sendsPayDeposits == true;
        }
    },
    actions: {
        async load({commit}, employerId){      
            if(!employerId) return;            
            let settings = await romeApi.get(`employer/${employerId}/edi/settings`);      
                                        
            commit("setSettings", settings);                     
        },
        async updateSettings({commit, state}, data) {            
            if (!state.employerId) return;
            let activeChanged = state.active != data.active            
            await romeApi.post(`employer/${state.employerId}/edi/settings`, data);                
            commit("setSettings", data);
            if(activeChanged){ //If Employer swaps from test to live
                let files = await romeApi.get(`employer/${state.employerId}/edi/recentfiles`);    
                commit("setFiles", files);
            }
        },
        async updateFiles({commit, state}){
            let files = await romeApi.get(`employer/${state.employerId}/edi/recentfiles`);                
            commit("setFiles", files);
        }
    }, 
    mutations: {
        setSettings(state, data){
            if(!data) utils.resetStoreStateProperties(state);
            utils.copyCommonProperties(data, state);
        },
        setFiles(state, data){            
            state.files = data;
        }
    }
}

export default storeEmployerEdi;



// WEBPACK FOOTER //
// ./src/edi/x-employer-edi.js